<template>
  <div class="container-xxl py-24">
    <MetaTags
      title="Помощь"
      description="Помощь"
    />
    <AppBreadcrumbs
      :links="[
        {
          text: 'Помощь'
        }
      ]"
    />
    <h1 class="fw-bold mb-15">
      Помощь
    </h1>
    <div class="row">
      <div
        class="col-12 col-md-4 d-flex flex-md-column gap-15 mb-25 mb-md-0"
        style="overflow-x: auto"
      >
        <NuxtLink
          class="rounded-pill w-100 p-24 text-center text-nowrap text-decoration-none"
          :class="theme == 1 ? 'bg-apply text-primary fw-bold' : 'bg-white text-black'"
          to="?theme=1"
          @click="changeTheme(1)"
        >
          Для соискателя
        </NuxtLink>
        <NuxtLink
          class="rounded-pill w-100 p-24 text-center text-nowrap text-decoration-none"
          :class="theme == 2 ? 'bg-apply text-primary fw-bold' : 'bg-white text-black'"
          to="?theme=2"
          @click="changeTheme(2)"
        >
          Для работодателя
        </NuxtLink>
        <NuxtLink
          class="rounded-pill w-100 p-24 text-center text-nowrap text-decoration-none"
          :class="theme == 3 ? 'bg-apply text-primary fw-bold' : 'bg-white text-black'"
          to="?theme=3"
          @click="changeTheme(3)"
        >
          Написать в службу поддержки
        </NuxtLink>
      </div>
      <div class="col-12 col-md-8">
        <div class="rounded-20 px-20 py-34 bg-white">
          <div
            v-if="theme === 1 || theme === 2"
            class="accordion accordion-number"
          >
            <div
              v-for="(item, index) in getFAQ"
              class="accordion-item"
            >
              <button
                class="accordion-button"
                :class="openAccordion === index ? '' : 'collapsed'"
                type="button"
                aria-expanded="false"
                @click="openAccordion = index"
              >
                <div class="position-relative d-flex w-100">
                  <div class="accordion-content">
                    <h2 class="accordion-header">
                      {{ item.title }}
                    </h2>
                    <div
                      class="accordion-collapse"
                      :class="openAccordion === index ? '' : 'collapse'"
                    >
                      <div class="accordion-body">
                        {{ item.body }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-arrow">
                  <svg
                    width="20"
                    height="11"
                    viewBox="0 0 20 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    data-inject-url="https://peterdraw.studio/ziro-html/assets/icons/chevron-down.svg"
                    class="svg-inject svg-icon"
                  >
                    <path d="M19.6273 1.77879L10.6273 9.77878C10.4448 9.9391 10.2102 10.0275 9.96728 10.0275C9.72437 10.0275 9.48977 9.9391 9.30728 9.77878L0.307278 1.77879C0.121445 1.6003 0.0116842 1.35696 0.000880246 1.09952C-0.00992376 0.842077 0.0790634 0.5904 0.249287 0.396964C0.419511 0.203528 0.657833 0.0832638 0.91456 0.0612484C1.17129 0.039233 1.42661 0.117165 1.62728 0.278796L9.96728 7.68878L18.3073 0.278796C18.4046 0.185284 18.5199 0.112452 18.6462 0.0646883C18.7724 0.0169249 18.9071 -0.00478066 19.0419 0.000879482C19.1768 0.00653962 19.3091 0.0394483 19.4309 0.0976224C19.5528 0.155797 19.6615 0.238031 19.7507 0.339371C19.8399 0.440711 19.9076 0.559058 19.9498 0.687279C19.9921 0.8155 20.0079 0.950941 19.9963 1.08544C19.9848 1.21994 19.9462 1.35071 19.8827 1.46987C19.8193 1.58903 19.7324 1.69412 19.6273 1.77879Z" />
                  </svg>
                </div>
              </button>
            </div>
          </div>
          <div v-else>
            <div class="fw-bold w-100 mb-15">
              Тема
              <SelectLayout
                v-model="formTheme"
                :reduce="(option) => option.id"
                :options="supportThemList"
                class="form-control"
                :class="$v.formTheme.$error ? 'is-invalid' : ''"
                target="cities"
                :clearable="false"
              />
            </div>
            <label class="fw-bold w-100 mb-15">
              Ваш email
              <input
                v-model="formEmail"
                type="email"
                class="form-control"
                :class="$v.formEmail.$error && !isSend ? 'is-invalid' : ''"
              >
            </label>
            <label class="fw-bold w-100 mb-15">
              Текст сообщения
              <textarea
                v-model="formMessage"
                class="form-control"
                :class="$v.formMessage.$error && !isSend ? 'is-invalid' : ''"
              />
            </label>
            <AppButton
              class="mx-auto d-block fw-bold mt-10"
              @click="send"
            >
              Отправить
            </AppButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SelectLayout from "~/components/inputs/selectLayout.vue";
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import {supportThemList} from "~/composables/SupportThemList";

const { $toast } = useNuxtApp();
const route = useRoute();

//-----VARIABLES-----\\
const forClient = [
  {
    title: 'Что такое видеорезюме и видеовакансия?',
    body: 'Видеорезюме – это короткое видео, где соискатель отвечает на стандартные вопросы об опыте и мотивации. видеовакансия – это видео от работодателя, в котором описывается вакансия, требования к кандидату и условия работы.',
  },
  {
    title: 'Как мне создать видеорезюме?',
    body: 'Перейдите к созданию видеорезюме. Далее необходимо пройти короткую анкету (1-2 этап) и ответить на предложенные вопросы на камеру. В правилах записи видео есть рекомендации, чтобы видеорезюме получилось профессиональным и привлекательным.',
  },
  {
    title: 'Могу ли я редактировать своё видеорезюме после его загрузки?',
    body: 'Да, вы можете редактировать или перезаписывать своё видеорезюме в любое время.',
  },
  {
    title: 'Какие технические требования для записи видео?',
    body: 'Вам понадобится устройство с камерой (смартфон, планшет или компьютер), стабильное интернет-соединение и хорошее освещение. Мы рекомендуем записывать видео в тихом месте, чтобы обеспечить хорошее качество звука.',
  },
  {
    title: 'Видео не загружается. Что делать?',
    body: 'Убедитесь, что ваше интернет-соединение стабильно. Если проблема сохраняется, обратитесь в службу поддержки.',
  },
  {
    title: 'Как загрузить видео, если у меня нет камеры на устройстве?',
    body: 'Загрузка видео предусматривает только запись с устройства.',
  },
  {
    title: 'Как я могу связаться с работодателем после создания видеорезюме?',
    body: 'Если работодатель заинтересуется вашим видеорезюме, он может пригласить вас на СОБЕС или дать дополнительные вопросы на запись. Вы получите уведомление на платформе и на подключенный мессенджер. Также вы можете сами написать работодателю по контактам, которые указаны в деталях вакансии.',
  },
  {
    title: 'Как проходит СОБЕС?',
    body: 'СОБЕСЫ проходят прямо на нашей платформе, либо на другой выбранной работодателем. Вам нужно будет открыть сайт в назначенное время и принять звонок, далее ответить на вопросы работодателя в реальном времени.',
  },
  {
    title: 'Как защищены мои данные?',
    body: 'Мы принимаем все необходимые меры для защиты ваших данных, включая использование шифрования и регулярное обновление наших систем безопасности.',
  },
  {
    title: 'Кто может видеть моё видеорезюме?',
    body: 'Ваше видеорезюме могут видеть все пользователи. Вы можете контролировать видимость к вашему видео, через настройки.',
  },
  {
    title: 'Как удалить своё видеорезюме с платформы?',
    body: 'Полностью удалить видеорезюме нельзя. Вам нужно перейти в редактирование, выбрать последний этап “Публикация” и в поле “Видимость” выбрать “Скрыто”.',
  },
];
const forCompany = [
  {
    title: 'Что такое видеорезюме и видеовакансия?',
    body: 'видеорезюме – это короткое видео, где соискатель отвечает на стандартные вопросы об опыте и мотивации. видеовакансия – это видео от работодателя, в котором описывается вакансия, требования к кандидату и условия работы.',
  },
  {
    title: 'Как создать видеовакансию?',
    body: 'Перейдите к созданию видеовакансии. Далее необходимо пройти короткую анкету (1 этап) и ответить на предложенные вопросы на камеру. В правилах записи видео есть рекомендации, чтобы видеовакансия получилось профессиональным и привлекательным.',
  },
  {
    title: 'Какие преимущества видеорезюме и видеовакансий?',
    body: 'Видео позволяет лучше оценить личные качества и коммуникативные навыки кандидатов, а также делает процесс найма более прозрачным и интерактивным.',
  },
  {
    title: 'Какие технические требования для записи видео?',
    body: 'Вам понадобится устройство с камерой (смартфон, планшет или компьютер), стабильное интернет-соединение и хорошее освещение. Мы рекомендуем записывать видео в тихом месте для обеспечения хорошего качества звука.',
  },
  {
    title: 'Видео не загружается. Что делать?',
    body: 'Убедитесь, что ваше интернет-соединение стабильно. Если проблема сохраняется, обратитесь в службу поддержки.',
  },
  {
    title: 'Как загрузить видео, если у меня нет камеры на устройстве?',
    body: 'Загрузка видео предусматривает только запись с устройства.',
  },
  {
    title: 'Как я могу связаться с кандидатом после просмотра видеорезюме?',
    body: 'Если вас заинтересовало видеорезюме кандидата, вы можете пригласить его на СОБЕС или дать дополнительные вопросы. Также, в деталях видеорезюме есть контакты, по которым можно связаться напрямую.',
  },
  {
    title: 'Как проходит СОБЕС?',
    body: 'СОБЕСЫ проходят прямо на нашей платформе. Но можно пригласить на любую другую платформу. Вы назначаете место, время и дату и. В назначенное время, задаете вопросы кандидату через видеосвязь.',
  },
  {
    title: 'Могу ли я фильтровать кандидатов по определённым критериям?',
    body: 'Нет, на данный момент фильтр идёт только по городу и профессии. Фильтр по остальным параметрам будет разработан чуть позже.',
  },
  {
    title: 'Как защищены данные моей компании?',
    body: 'Мы принимаем все необходимые меры для защиты ваших данных, включая использование шифрования и регулярное обновление наших систем безопасности.',
  },
  {
    title: 'Кто может видеть мои видеовакансии?',
    body: 'Ваши видеовакансии могут видеть все пользователи. Вы можете контролировать видимость к вашему видео, через настройки.',
  },
  {
    title: 'Как удалить видеовакансию с платформы?',
    body: 'Чтобы удалить видеовакансию, вам нужно переместить её в “Архив”.',
  },
];

//-----STATE-----\\
const theme = ref<number>(route.query.theme === undefined ? 1 : Number(route.query.theme));
const openAccordion = ref<number>(0);
const formTheme = ref<number>(route.query.formTheme === undefined ? undefined : Number(route.query.formTheme));
const formEmail = ref<string>();
const formMessage = ref<string>();
const isSend = ref<boolean>(false);

//-----COMPUTED-----\\
const $v = useVuelidate({
  formTheme: { required },
  formEmail: { required, email },
  formMessage: { required },
}, { formTheme, formEmail, formMessage });

const getFAQ = computed<Object[]>(() => {
  if (theme.value === 1) {
    return forClient;
  } else if (theme.value === 2) {
    return forCompany;
  }
  return [];
});

//-----METHODS-----\\
function changeTheme(index: number) {
  if (theme.value === index) {
    return;
  }
  theme.value = index;
  openAccordion.value = 0;
}
function send() {
  isSend.value = false;
  $v.value.$touch();
  if ($v.value.$error) {
    return;
  }

  mainFetch('help-requests', {
    method: 'POST',
    body: {
      theme: formTheme.value,
      email: formEmail.value,
      message: formMessage.value,
    }
  }).then(({ status }) => {
    if (status.value !== "success") {
      $toast.success('Сообщение не отправлено');
      return
    }

    formTheme.value = 1;
    formEmail.value = '';
    formMessage.value = '';
    isSend.value = true;
    $toast.success('Сообщение успешно отправлено');
  });
}
</script>